/**
 * @deprecated
 */

var $ = require('jquery');

var fg = {};

/**
 * Inherit the prototype methods from one constructor into another.
 * @param {Function} childCtor Child class.
 * @param {Function} parentCtor Parent class.
 */
fg.inherits = function(childCtor, parentCtor) {
    /** @constructor */
    function tempCtor() {
    };
    tempCtor.prototype = parentCtor.prototype;
    childCtor.superClass_ = parentCtor.prototype;
    childCtor.prototype = new tempCtor();
    /** @override */
    childCtor.prototype.constructor = childCtor;
};

/**
 *
 * @param {Function} ctor
 */
fg.addSingletonGetter = function(ctor) {
    ctor.getInstance = function() {
        if (ctor.instance_) {
            return ctor.instance_;
        }
        return ctor.instance_ = new ctor;
    };
};

/**
 *
 * @param {Function} jsClass
 */
fg.makeJQueryPlugin = function(jsClass) {
    if (!jsClass.COMPONENT_NAME) {
        throw Error('Trida nema definovano COMPONENT_NAME');
    }
    $.fn[jsClass.COMPONENT_NAME] = function(options) {
        return this.each(function(index, element) {
            if (options == 'dataset') {
                options = $(element).data();
            }
            var instance = new jsClass(options).decorate(element);
            $(element).data(jsClass.COMPONENT_NAME, instance);
        });
    };
};

/**
 * Call up to the superclass.
 *
 * If this is called from a constructor, then this calls the superclass
 * contsructor with arguments 1-N.
 *
 * If this is called from a prototype method, then you must pass the name of the
 * method as the second argument to this function. If you do not, you will get a
 * runtime error. This calls the superclass' method with arguments 2-N.
 *
 * This function only works if you use fg.inherits to express inheritance
 * relationships between your classes.
 *
 * This function is a compiler primitive. At compile-time, the compiler will do
 * macro expansion to remove a lot of the extra overhead that this function
 * introduces. The compiler will also enforce a lot of the assumptions that this
 * function makes, and treat it as a compiler error if you break them.
 *
 * @param {!Object} me Should always be "this".
 * @param {*=} opt_methodName The method name if calling a super method.
 * @param {...*} var_args The rest of the arguments.
 * @return {*} The return value of the superclass method.
 */
fg.base = function(me, opt_methodName, var_args) {
    var caller = arguments.callee.caller;

    /*    if (goog.DEBUG) {
     if (!caller) {
     throw Error('arguments.caller not defined.  goog.base() expects not ' +
     'to be running in strict mode. See ' +
     'http://www.ecma-international.org/ecma-262/5.1/#sec-C');
     }
     }*/

    if (caller.superClass_) {
        // This is a constructor. Call the superclass constructor.
        return caller.superClass_.constructor.apply(
            me, Array.prototype.slice.call(arguments, 1));
    }

    var args = Array.prototype.slice.call(arguments, 2);
    var foundCaller = false;
    for (var ctor = me.constructor;
         ctor; ctor = ctor.superClass_ && ctor.superClass_.constructor) {
        if (ctor.prototype[opt_methodName] === caller) {
            foundCaller = true;
        } else if (foundCaller) {
            return ctor.prototype[opt_methodName].apply(me, args);
        }
    }

    // If we did not find the caller in the prototype chain, then one of two
    // things happened:
    // 1) The caller is an instance method.
    // 2) This method was not called by the right caller.
    if (me[opt_methodName] === caller) {
        return me.constructor.prototype[opt_methodName].apply(me, args);
    } else {
        throw Error(
            'goog.base called from a method of one name ' +
            'to a method of a different name');
    }
};

/**
 * Returns an object based on its fully qualified external name.  The object
 * is not found if null or undefined.  If you are using a compilation pass that
 * renames property names beware that using this function will not find renamed
 * properties.
 *
 * @param {string} name The fully qualified name.
 * @param {Object=} opt_obj The object within which to look; default is
 *     |goog.global|.
 * @return {?} The value (object or primitive) or, if not found, null.
 */
fg.getObjectByName = function(name, opt_obj) {
    var parts = name.split('.');
    var cur = opt_obj || window;
    for (var part; part = parts.shift(); ) {
        if (cur[part] != null) {
            cur = cur[part];
        } else {
            return null;
        }
    }
    return cur;
};
module.exports = fg;




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/base.js